import { Variable } from "../model/variable/variable";

export abstract class ComponentVariable {
	abstract getValue(): any;
	abstract setValue(value: any): void;
	abstract getVariable(): Variable;
	abstract onChangeCallback(): void;

	public getLegendClass(): string {
		const legend = this.getVariable().legend;
		const value = +this.getValue().value;
		if (value != undefined && legend) {
			if (legend.damage && value > legend.damage) {
				return 'var-legend-damage';
			} else if (legend.control && value > legend.control) {
				return 'var-legend-control';
			} else if (legend.alert && value > legend.alert) {
				return 'var-legend-alert';
			} else {
				return 'var-legend-noaction';
			}
		}
		return '';
	}

	public getLegendColor(): string {
		const legend = this.getVariable().legend;
		const value = +this.getValue().value;
		if (value != undefined && legend) {
			if (legend.damage && value > legend.damage) {
				return '#c64840';
			} else if (legend.control && value > legend.control) {
				return '#ea9b3e';
			} else if (legend.alert && value > legend.alert) {
				return '#00b28e';
			} else {
				return '#1485c7';
			}
		}
		return '';
	}
	
}